import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const DATA_AUTOMATION_FILTER_WRAPPER = (id: string) =>
    generateAutomationName("home", ["list", "filters", "container", id]);
